import React from "react";
import "./HRNewsletter.css";

const HRNewsletter = () => {
  return (
    <section className="hrn-section">

      {/* LEFT TEXT BLOCK */}
      <div className="hrn-left">
        <p className="hrn-subtitle">KEEP UP TO DATE WITH Humanex</p>

        <h2 className="hrn-title">
          Subscribe to <br />
          <span>Our Newsletter</span>
        </h2>

        <p className="hrn-desc">
          Sign up for Humanex newsletter to receive all the new offers and discounts
          regarding the HR projects you might have. Simply type in your email
          address and we’ll include you in our next update.
        </p>

        {/* INPUT + BUTTON */}
        <div className="hrn-form">
          <input type="email" placeholder="Enter your email address" />
          <button>SUBSCRIBE NOW</button>
        </div>
      </div>

      {/* RIGHT IMAGE */}
      <div className="hrn-right">
        <img
          src="https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/bgn-newsletter.jpg"
          alt="newsletter"
          className="hrn-image"
        />
      </div>

      {/* CURVE SHAPE */}
      <img
        src="https://avantage.bold-themes.com/hr/wp-content/uploads/sites/5/2019/04/bgn-newsletter-curve.png"
        alt="curve"
        className="hrn-curve"
      />
    </section>
  );
};

export default HRNewsletter;
